/* The sticky control submits the real product form, including selected variant and quantity. */
(() => {
  'use strict';
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const sticky = root.querySelector('[data-sticky-buy]');
    const purchase = root.querySelector('[data-product-form] [data-add-button]');
    const stickyButton = root.querySelector('[data-sticky-add]');
    if (!sticky || !purchase || !stickyButton || !window.IntersectionObserver) return;
    let passed = false;
    const update = () => {
      const cookieBanner = document.querySelector('#shopify-pc__banner');
      const cookieVisible = cookieBanner && cookieBanner.getBoundingClientRect().height > 0;
      sticky.hidden = !passed || stickyButton.disabled || cookieVisible;
    };
    const observer = new IntersectionObserver(([entry]) => { passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0; update(); });
    observer.observe(purchase);
    root.addEventListener('herbaclean:variant-updated', update);
    new MutationObserver(() => { stickyButton.disabled = purchase.disabled; update(); }).observe(purchase, { attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('visitorConsentCollected', () => setTimeout(update, 0));
    window.addEventListener('resize', update, { passive: true });
  });
})();
